import { useQuery } from '@tanstack/react-query';
import { IGetAllOffersResponse } from "../../utils/types";
import { apiManager } from "../api-manager";
import { apiClient } from '../api-manager-instance';
import { ENDPOINTS } from '../endpoints';

export const getAllReferralOffers = async (params?: {
  page?: number;
  userType?: string;
  limit?: string;
  startDate?: string;
  expiryDate?: string
  sort?: string;
  isActive?: string;
}) => {
  const res = await apiManager.get<IGetAllOffersResponse>(
    "referral-offer/get-all-offers",
    params
  );
  return res;
};


export const useGetAllReferralOffers = (params?: {
  page?: number;
  userType?: string;
  limit?: string;
  startDate?: string;
  expiryDate?: string;
  sort?: string;
  isActive?: string;
}) =>
  useQuery({
    queryKey: ["get_all_referral_offers", params],
    queryFn: async (): Promise<IGetAllOffersResponse> => {
      const res = await apiClient.get(ENDPOINTS.REFERRAL_OFFERS.GET_ALL, { params });
      return res.data;
    },
  });